import type { LangCode, OptionNewItemQuery } from "@/lib/gql/__generated__/graphql";

import { useTransitionBlock } from "@/hooks/use-transition-block";

import { NameOfResourceBeingEdited } from "@/components/features/_components";
import {
	FeatureIslandContainer,
	FeatureIslandHeader,
	FeatureIslandMainWithCategory,
} from "@/components/features/_layouts";

import { HeaderActions } from "./header/actions";
import { useInitialized } from "../../../model/usecase/new/use-init";
import { OptionForm } from "../../_shared/components/root";
import { standardOptionCategoriesAndManagerStore } from "../../_shared/store/categories";
import { ProductNewOptionFormModelContextProvider } from "../context";

type Props = {
	activeLangCode: LangCode;
	serverModel: OptionNewItemQuery;
};

export const NewOptionEditPresenter = ({ serverModel, activeLangCode }: Props) => {
	const init = useInitialized({ serverModel });

	const { categoryManagerStore } = standardOptionCategoriesAndManagerStore;

	const { isDirty } = init.viewModel;
	useTransitionBlock(isDirty);

	const optionName = init.viewModel.name.value;

	return (
		<ProductNewOptionFormModelContextProvider value={{ ...init }}>
			<FeatureIslandContainer>
				<FeatureIslandHeader
					title="新規オプション作成"
					activeLangCode={activeLangCode}
					rightChildren={<HeaderActions />}
				/>
				<FeatureIslandMainWithCategory categoryManagerStore={categoryManagerStore}>
					{/* @todo Layout の共通化が出来るまでは共通化しない */}
					<NameOfResourceBeingEdited resourceName={optionName} />

					<OptionForm roomCategoriesAndManagerStore={standardOptionCategoriesAndManagerStore} />
				</FeatureIslandMainWithCategory>
			</FeatureIslandContainer>
		</ProductNewOptionFormModelContextProvider>
	);
};

NewOptionEditPresenter.displayName = "NewOptionEditPresenter";
